module.exports = __webpack_public_path__ + "img/assets-grey.03e5c520.svg";